import { makeStyles } from 'tss-react/mui';

export const useCatalogGridCriteriaCardStyles = makeStyles()((theme) => ({
  availabilityChip: {
    justifyContent: 'flex-start !important',
    paddingLeft: 0,
    fontColor: 'text.secondary',
  },
  availabilityFieldsContainer: {
    padding: theme.spacing(0.5, 0.75),
    gap: theme.spacing(1),
  },
}));
